// just the env vars that are needed to run the infra
export const requiredEnvVars = [
  'REACT_APP_PAYMENT_API_DOMAIN',
  'REACT_APP_MSAL_CLIENT_ID',
  'REACT_APP_MSAL_TENANT',
  'REACT_APP_UNZER_MERCHANT_ID',
  'REACT_APP_DOCUMENT_SERVICE_URL',
  'REACT_APP_APP_URL',
  'REACT_APP_ADYEN_CLIENT_KEY',
  'REACT_APP_ADYEN_MERCHANT_ACCOUNT',
  'REACT_APP_ADYEN_ENVIRONMENT',
  'REACT_APP_GB_ADMIN_UI'
]
